<template>
 <div>
  <apexchart
   :width="this.width"
   :height="this.height"
   :options="chartOptions"
   :series="this.seriesForColumn ? this.seriesForColumn : series"
  ></apexchart>
 </div>
</template>

<script>
export default {
 name: "BasicColumnChart",
 props: [
  "seriesForColumn",
  "categoriesForColumn",
  "width",
  "height",
  "colors",
  "title",
  "totalAnswered",
  "totalUnanswered",
 ],
 data() {
  return {
   series: [],
   chartOptions: {
    title: {
     text: this.title,
     align: "left",
     margin: 10,
     offsetX: 0,
     offsetY: 0,
     floating: false,
     style: {
      fontSize: "14px",
      fontWeight: "bold",
      fontFamily: undefined,
      color: "#263238",
     },
    },
    noData: {
     text: "No data",
     align: "center",
     verticalAlign: "middle",
     offsetX: 0,
     offsetY: 0,
     style: {
      color: undefined,
      fontSize: "14px",
      fontFamily: undefined,
     },
    },

    colors: ["#97BAA6", "#E34B5F", "#1E7889"],
    chart: {
     type: "bar",
    },
    plotOptions: {
     bar: {
      horizontal: false,
      columnWidth: "55%",
      endingShape: "rounded",
     },
    },
    dataLabels: {
     enabled: false,
    },
    xaxis: {
     categories: this.categoriesForColumn ? this.categoriesForColumn : [],
     labels: {
      rotate: -75,
      rotateAlways: true,
      style: {
       colors: [],
       fontSize: "12px",
       fontFamily: "Helvetica, Arial, sans-serif",
       fontWeight: 500,
       cssClass: "apexcharts-xaxis-label",
      },
      /**
       * Allows users to apply a custom formatter function to x-axis labels.
       *
       * @param { String } value - The default value generated
       * @param { Number } timestamp - In a datetime series, this is the raw timestamp
       * @param { object } contains dateFormatter for datetime x-axis
       */
      formatter: function (value, timestamp, opts) {
       let finalValue = "";
       if (value.length > 0) {
        let valueFirstTwo = value.slice(0, 2);
        let valueLastTwo = value.slice(-2);
        if (value.length == 4) {
         finalValue = valueFirstTwo + ":" + valueLastTwo;
        } else if (value.length == 2) {
         finalValue = valueFirstTwo + ":" + "00";
        }
       }

       return value;
      },
     },
    },
    yaxis: {
     title: {
      text: "calls count",
     },
    },
   },
  };
 },
 methods: {},
 mounted() {
  this.$emit("loading", false);
 },
};
</script>

<style></style>
